import angular from 'angular';
import _ from 'lodash';

const DAY = 1000 * 60 * 60 * 24; // 24 hours

function toStoreSorting (sorting) {
    let ordering = [];
    // params.sorting() give you field -> order obj
    // we need to transform it to django filters (field or -field)
    for (let [field, order] of _.toPairs(sorting) ) {
        ordering.push(`${order === 'asc' ? '': '-' }${field}`);
    }
    return ordering;

}

function toNgTableSorting (ordering) {
    ordering = ordering || [];
    return _.fromPairs(ordering.map(function(v) {
        let order = 'asc';
        if (v.startsWith('-')) {
            v = v.substring(1);
            order = 'desc';
        }
        return [v, order];
    }))
}

function toArray (value) {
    if (value && !_.isArray(value)) {
        return [value];
    }
    return value;
}


export default class TableList {
    constructor (NgTableParams, Store, {defaultParams = {}, params = {}, onChange = function(){}}){
        defaultParams = _.clone(defaultParams);
        params = _.clone(params);
        defaultParams.page = defaultParams.page || 1;

        let self = this;
        self._onChange = onChange || function(){};
        self.defaultParams = defaultParams;
        self.isPaginationEnabled = !!this.defaultParams.page_size;

        let requestParams = _.extend(_.clone(defaultParams), params);
        let ordering = toArray(requestParams.ordering || this.defaultParams.ordering);

        let ngParams = {
            count: this.defaultParams.page_size || 100000000,
            sorting: toNgTableSorting(ordering),
        };

        self.store = Store;
        self.store.init();
        self.store.params = requestParams;
        self.initialized = false;

        this.params = new NgTableParams(
            ngParams,
            {
                counts: [],
                paginationMinBlocks: 2,
                paginationMaxBlocks: 10,
                getData: function (params) {
                    if (!self.store) {
                        // Destroy data from ngTable.
                        // I did not find any different way to cleanup data
                        return [];
                    }
                    if (!self.initialized){
                        params.page(self.store.params.page);
                    }
                    self.store.params.ordering = toStoreSorting(params.sorting());

                    if (self.isPaginationEnabled) {
                        self.store.params.page = params.page();
                    }
                    if (self.initialized) {
                        self.onChange();
                    } else {
                        self.initialized = true;
                    }

                    return self.store.refresh().then(function (store) {
                        // recal. page nav controls
                        params.total(store.count);
                        // return data
                        return store.list;
                    });
                },
            },
        );

        this.allChecked = false;
        this.checked = {};
    }

    getSelected () {
        let checked = this.checked;
        return _.map(_.filter(_.keys(checked), (key) => checked[key]), (key) => key);
    }

    getSelectedObjects () {
        let checked = this.checked;
        let objects = {};

        _.each(this.store.list, function (obj) {
            objects[obj.id] = obj;
        });

        return _.map(_.filter(_.keys(checked), function(id) {
            return checked[id];
        }), function(id) {
            return objects[id];
        });
    }

    updateAllChecked () {
        let self = this;

        if (_.isEmpty(self.checked)) {
            self.allChecked = false;
            return;
        }
        self.allChecked = _.every(self.store.list, (o) => self.checked[o.id]);
    }

    allCheckedToggle () {
        let self = this;
        let value = !self.allChecked;
        self.allChecked = value;

        _.map(self.store.list, (obj) => {
            self.checked[obj.id] = value;
        });
    }

    onChange () {
        let params = {};
        for (let k of Object.keys(this.store.params)) {
            let v = this.store.params[k];
            if (!_.isEqual(v, this.defaultParams[k])) {
                params[k] = v;
            }
        }
        this._onChange(params);
    }

    refresh (params) {
        params = params || {};
        this.params.page(1);
        this.params.sorting(toNgTableSorting(toArray(params.ordering)));
        this.store.params = _.clone(params);
        this.params.reload();
    }

    onDestroy () {
        delete this.store;
        this.params.settings().dataset = [];
        this.params.reload();
    }

    inProgressTime(ticketId) {
        const ticket = this.params.data.find(t => t.id === ticketId);
        if (!ticket) return 0;

        let time = 0;
        if (ticket.delivery_start && !ticket.delivery_stop) {
            time = new Date() - Date.parse(ticket.delivery_start);
        }
        if (!time && ticket.application_start && !ticket.application_stop) {
            time = new Date() - Date.parse(ticket.application_start);
        }

        return time;
    }

    isInProgressCorrect (ticketId) {
        const time = this.inProgressTime(ticketId);
        if (time === 0) return false;
        return time < DAY;
    }

    isInProgressTooLong(ticketId) {
        const time = this.inProgressTime(ticketId);
        return time >= DAY;
    }

}



// WEBPACK FOOTER //
// ./src/app/common/table.js